import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { JSONTree } from 'react-json-tree';
import { maskNumbers, removeHtmlTag } from '../../util/utils';

import SidebarContainer from '../SidebarContainer';
import dealActions from '../../redux/deals/actions';
import './Deal.scss';

import ContentPage from '../ContentPage';

class Deal extends Component {
  /**
   * Lifecycle hook method for Deal class
   *
   * @return  null
   */
  componentDidMount() {
    const dealId = this.props.match.params.dealId;
    this.props.actions.dealRequest({ dealId });
  }

  /**
   * Go Back in Router History
   * Return to previous page
   *
   * @return  null
   */
  back = () => {
    this.props.history.goBack();
  };

  /**
   * Lifecycle hook method for Deal class
   * Renders Deals Elements
   *
   * @return  JSX
   */
  render() {
    const deal = this.props.deal;
    if (!deal) {
      return null;
    }

    if (deal?.applicant?.socialSec) {
      deal.applicant.socialSec = maskNumbers(deal.applicant.socialSec);
    }

    if (deal?.coapplicant?.socialSec) {
      // @see https://upstartnetwork.atlassian.net/browse/REL-13381
      deal.coapplicant.socialSec = maskNumbers(deal.coapplicant.socialSec);
    }

    // deal manager should just see uploaded documents link for the crmNote in the deal page.
    if (deal?.crmNote) {
      deal.crmNote = removeHtmlTag(deal.crmNote);
    }

    const dealJSON = (
      <div>
        <div className="column">
          <h3>
            <button
              type="button"
              className="btn btn-secondary float-left margin-right"
              onClick={this.back}
            >
              Go Back
            </button>
            Deal <strong>{deal.id}</strong>
          </h3>
          <ul className="list-inline">
            <li>
              Created <strong>{deal.createdAt}</strong>
            </li>
          </ul>
        </div>
        <div className="tree-container">
          <span className="col-md-10">
            <JSONTree data={deal} />
          </span>
        </div>
      </div>
    );
    return (
      <SidebarContainer>
        <div className="deal-detail-container amp-mask" data-dd-privacy="mask">
          {dealJSON}
        </div>
      </SidebarContainer>
    );
  }
}

/**
 * PropTypes Definition for Deal Class
 */
Deal.propTypes = {
  actions: PropTypes.object,
  deal: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deal: state.deals.deal,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(dealActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Deal));
